import FloatLabels from 'float-labels.js';
import Choices from 'choices.js';

let Core = {
	externalLinks: () => {
		let links = document.links;

		for (let i = 0, linksLength = links.length; i < linksLength; i++) {
			if (links[i].hostname !== window.location.hostname) {
				links[i].target = '_blank';
			}
		}
	},
	init: () => {
		Core.externalLinks();
		Core.initHelpers();
	},
	initHelpers: () => {
		// Float labels
		let floatlabels = new FloatLabels( 'form', {
			customEvent      : null,
			customLabel      : null,
			customPlaceholder: null,
			exclude          : '.no-label',
			inputRegex       : /email|number|password|search|tel|text|url/,
			prefix           : 'fl-',
			prioritize       : 'label',
			requiredClass    : 'required',
			style            : 2,
			transform        : 'input,select,textarea',
		});

		// Tippy
		tippy.setDefaults({
			theme: 'ess-tooltip',
			arrow: true,
			arrowType: 'sharp',
			duration: 200,
			interactive: true,
			// performance: true,
			livePlacement: true,
			placement: 'top',
			sticky: true,
			animation: 'shift-toward',
			// trigger: 'click'
		})

		if (document.querySelector('select[multiple]')) {
			const choices = new Choices('select[multiple]', {
				silent: true,
				// items: [],
				// choices: [],
				// renderChoiceLimit: -1,
				// maxItemCount: -1,
				// addItems: true,
				// addItemFilterFn: null,
				// removeItems: true,
				removeItemButton: true,
				// editItems: false,
				// duplicateItemsAllowed: true,
				// delimiter: ',',
				paste: true,
				searchEnabled: true,
				searchChoices: true,
				searchFloor: 1,
				searchResultLimit: 4,
				searchFields: ['label', 'value'],
				position: 'auto',
				resetScrollPosition: true,
				shouldSort: true,
				shouldSortItems: false,
				// placeholder: true,
				// placeholderValue: null,
				// searchPlaceholderValue: null,
				// prependValue: null,
				// appendValue: null,
				renderSelectedChoices: 'auto',
				loadingText: 'Nalagam ...',
				noResultsText: 'Ni iskanih rezultatov',
				noChoicesText: 'Ni opcij za izbiro',
				itemSelectText: '',
				addItemText: (value) => {
					return `Pritisni Enter, da dodaš <b>"${value}"</b>`;
				},
				maxItemText: (maxItemCount) => {
					return `Doda se lahko največ ${maxItemCount} opcij(a)`;
				},
				// itemComparer: (choice, item) => {
				// 	return choice === item;
				// },
				// classNames: {
				// 	containerOuter: 'choices',
				// 	containerInner: 'choices__inner',
				// 	input: 'choices__input',
				// 	inputCloned: 'choices__input--cloned',
				// 	list: 'choices__list',
				// 	listItems: 'choices__list--multiple',
				// 	listSingle: 'choices__list--single',
				// 	listDropdown: 'choices__list--dropdown',
				// 	item: 'choices__item',
				// 	itemSelectable: 'choices__item--selectable',
				// 	itemDisabled: 'choices__item--disabled',
				// 	itemChoice: 'choices__item--choice',
				// 	placeholder: 'choices__placeholder',
				// 	group: 'choices__group',
				// 	groupHeading: 'choices__heading',
				// 	button: 'choices__button',
				// 	activeState: 'is-active',
				// 	focusState: 'is-focused',
				// 	openState: 'is-open',
				// 	disabledState: 'is-disabled',
				// 	highlightedState: 'is-highlighted',
				// 	hiddenState: 'is-hidden',
				// 	flippedState: 'is-flipped',
				// 	loadingState: 'is-loading',
				// 	noResults: 'has-no-results',
				// 	noChoices: 'has-no-choices'
				// },
				// Choices uses the great Fuse library for searching. You
				// can find more options here: https://github.com/krisk/Fuse#options
				// fuseOptions: {
				// 	include: 'score'
				// },
				// callbackOnInit: null,
				// callbackOnCreateTemplates: null
			});
		}

	}
}
Core.init();
global.Core = Core;

// Live event binding
global.live = function live (eventType, elementQuerySelector, cb) {
	document.addEventListener(eventType, function (event) {
		var qs = document.querySelectorAll(elementQuerySelector);
		if (qs) {
			var el = event.target, index = -1;
			while (el && ((index = Array.prototype.indexOf.call(qs, el)) === -1)) {
				el = el.parentElement;
			}
			if (index > -1) {
				cb.call(el, event);
			}
		}
	});
}
